import client from '../ApolloClient'
import gql from 'graphql-tag'
import { failFetch } from '../Actions/Other'
// eslint-disable-next-line
import { Observable, Subject, filter, mergeMap, map } from 'rxjs'

import { FETCH_OVERVIEW, loadOverview } from '../Actions/Overview'

const overviewQuery = gql`query accountSummary($accountId: String!,
      $startDate: DateTime!, $endDate: DateTime!, $appProfileIds: [ID!], $groupIds: [ID!]) {
  accountSummary(accountId: $accountId, startDate: $startDate, endDate: $endDate, appProfileIds: $appProfileIds, groupIds: $groupIds){
    totalRegistration
    registrationsChange
    newContent
    newContentChangePct
    mostViewedContent {
      _id
      title
      totalViews
    }
    registrationPct
    totalMembers
    totalRegisteredUsers
    totalRegisteredPctChange
    mostLikedContent {
      _id
      title
      totalLikes
    }
    mostReactedContent {
      _id
      title
      totalLikes
      reactionCounts{
        _id
        count
      }
      totalReactions
    }
    mostCommentedContent {
      _id
      title
      totalComments
    }
    totalLogins
    totalLoginsPctChange
    avgMobileAppDuration
    avgMobileAppDurationChangePct
    avgWebAppDuration
    avgWebAppDurationChangePct
    absoluteTotalReg
    totalLicenses
    activeUsers
    accountDetails{
      _id
      name
      ui_version
    }
  }
}`

/**
  * overviewEpic
  * @desc action Observer that sends a query and processes result if the action is a fetch overview action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const overviewEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_OVERVIEW),
    mergeMap(action => {
      const subject = new Subject()
      client.query({ query: overviewQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadOverview(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )
